<template>
  <article class="ProgramTile">
    <TextBeta
      class="heading"
      v-text="heading"
    />
    <div class="image-wrapper">
      <BaseImage
        v-if="image"
        :id="image"
        class="image"
      />
      <ProgramAttributes
        v-if="attributes"
        :attributes="attributes"
        class="attributes attributes_inner"
      />
    </div>
    <ProgramAttributes
      v-if="attributes"
      :attributes="attributes"
      class="attributes attributes_outer"
    />
    <LinkButton
      :to="{ name: 'program', params: { category: $route.params.category, program: slug } }"
      class="link"
    >View {{ category }} Details</LinkButton>
  </article>
</template>

<script>
  import { fetchProgram } from '@/api/programs';

  import TextBeta from './TextBeta';
  import LinkButton from './LinkButton';
  import ProgramAttributes from './ProgramAttributes';

  export default {
    components: {
      TextBeta,
      LinkButton,
      ProgramAttributes,
    },
    props: {
      slug: {
        type: String,
        required: true,
      },
      category: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        image: undefined,
        heading: undefined,
        attributes: undefined,
      };
    },
    created() {
      this.fetch();
    },
    methods: {
      clean({
        acf: {
          ages,
          levels,
          tile: {
            image,
            heading,
          },
        },
        title: {
          rendered: name,
        },
      }) {
        return {
          image: image || null,
          heading: heading || name,
          attributes: [
            {
              name: 'Ages',
              value: ages,
            }, {
              name: 'Levels',
              value: levels,
            },
          ],
        };
      },
      async fetch() {
        const {
          image,
          heading,
          attributes,
        } = this.clean(await fetchProgram(this.slug));

        this.image = image;
        this.heading = heading;
        this.attributes = attributes;
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .attributes {
    padding-top: spacing(base-gamma);
    padding-bottom: spacing(base-gamma);

    &:first-child {
      margin-top: 10px;

      @include breakpoint(phablet) {
        margin-top: 0;
      }
    }

    @include breakpoint(tablet) {
      position: absolute;
      bottom: 0;
      left: 0;
      padding-right: spacing(base-gamma);
      padding-left: spacing(base-gamma);
    }
  }

  .attributes_inner {
    display: none;

    @include breakpoint(tablet) {
      display: flex;
    }
  }

  .attributes_outer {
    @include breakpoint(tablet) {
      display: none;
    }
  }

  .heading {
    color: color(bronze);
  }

  .image-wrapper {
    position: relative;
    margin-top: spacing(base-gamma);
    padding-top: percentage(9 / 16);

    @include breakpoint(phablet) {
      padding-top: percentage(3 / 4);
    }
  }

  .image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .link {
    display: inline-block;
    margin-top: spacing(base-gamma);
    color: color(white);
    background-color: color(bronze);
  }
</style>
